<template>
    <div v-if="showLabels" :class="['dml-product-thumb__labels', {'dml-product-thumb__labels--has-coupon': showCoupon}]">
        <div v-for="(labelsGroup, labelsGroupIndex) in labelsGroups">
            <div v-if="Array.isArray(labelsGroup)" :class="['dml-product-thumb__labels-items', labelsGroupClass[labelsGroupIndex]]">
                <dm-product-label v-for="label in labelsGroup"
                                  :key="label.badgeType"
                                  :type="getType(label)"
                                  v-on:click.native="emitClick(labels[label.badgeType].gaLabel)"
                                  :data-trc="labels[label.badgeType].dataTrc"
                                  :data-t="labels[label.badgeType].dataT">
                    <template v-if="label.badgeType === 0 && promoSale">
                        <img :src="promoSale.badgeImageUrl"
                             :srcset="`${promoSale.badgeLargeImageUrl} 2x`"
                             alt="Akcja promocyjna" />
                    </template>
                    <template v-if="label.badgeType === 3">
                        <component v-if="showCoupon"
                                   v-bind:is="couponComponent"
                                   v-on:click="couponClicked"
                                   class="dmv-button dml-label-coupon"
                                   :url="url"
                                   :model="coupon"
                                   :productId="productId">
                            <span class="dml-label-coupon__info">
                                KOD
                            </span>
                            <dm-icon v-if="isFreeDelivery"
                                     class="dml-label-coupon__icon"
                                     name="truck-fill"
                                     :width="16"
                                     :height="16" />
                            <span class="dml-label-coupon__value">
                                {{coupon && coupon.couponValue}}
                            </span>
                        </component>
                    </template>
                    <template v-if="label.badgeType === 5">
                        <dm-icon name="clock-2"
                                 :width="16"
                                 :height="16" />
                        {{labels[label.badgeType].text}}
                    </template>
                    <template v-else-if="label.badgeType === 7">
                        <dm-icon name="clock-2"
                             :width="16"
                             :height="16" />
                        {{labels[label.badgeType].text}}
                    </template>
                    <template v-else>
                        {{labels[label.badgeType].text}}
                    </template>
                </dm-product-label>
            </div>
        </div>
    </div>
</template>
<script>
    import ProductLabel from './product-label-component.vue';
    import ProductCoupon from './product-coupon-component.vue';
    import LightboxLink from './lightbox-link.vue';
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-product-labels',
        components: {
            'dm-product-label': ProductLabel,
            'dm-product-coupon': ProductCoupon,
            'dm-lightbox-link': LightboxLink,
            'dm-icon': IconComponent,
        },
        props: {
            url: {
                type: String,
                required: true
            },
            coupon: {
                type: Object
            },
            productId: {
                type: Number,
                required: true
            },
            labelsGroups: {
                type: Object,
                required: true
            },
            isLightboxEnabled: {
                type: Boolean,
                required: true
            },
            discountPercent: {
                type: String
            },
            showCoupon: {
                type: Boolean,
                required: false
            },
            promoSale: {
                type: Object,
                required: false
            }
        },
        computed: {
            showLabels() {
                return this.showTopLabels || this.showBottomLabels;
            },
            showTopLabels() {
                return this.labelsGroups.topBadges && this.labelsGroups.topBadges.length > 0;
            },
            showBottomLabels() {
                return this.labelsGroups.bottomBadges && this.labelsGroups.bottomBadges.length > 0;
            },
            couponComponent() {
                return this.isLightboxEnabled ? 'span' : 'dm-product-coupon';
            },
            isFreeDelivery() {
                return this.coupon && this.coupon.isFreeDelivery;
            },
            labelsGroupClass() {
                return {
                    topBadges: 'dml-product-thumb__labels-items--top',
                    bottomBadges: 'dml-product-thumb__labels-items--bottom'
                };
            },
            labels() {
                return {
                    0: {
                        text: '',
                        type: 'promo-sales',
                        gaLabel: 'badge_promo-sale',
                        dataT: '8.11'
                    },
                    1: {
                        text: 'Popularne',
                        type: 'white',
                        gaLabel: 'badge_bestseller',
                        dataT: '8.10'
                    },
                    2: {
                        text: 'Nowe',
                        type: 'white-circle',
                        gaLabel: 'badge_new',
                        dataT: '8.9'
                    },
                    3: {
                        text: this.coupon && this.coupon.couponValue,
                        type: this.showCoupon ? 'coupon' : 'hidden',
                        gaLabel: 'badge_coupon',
                        dataT: '8.5',
                        dataTrc: 'productThumb.coupon'
                    },
                    4: {
                        text: `-${this.discountPercent}`,
                        type: 'promo-circle',
                        gaLabel: 'badge_sale',
                        dataT: '8.8',
                        dataTrc: 'productThumb.sale'
                    },
                    5: {
                        text: 'Ostatnie szt.',
                        type: 'last-items',
                        gaLabel: 'badge_last',
                        dataTrc: 'productThumb.last'
                    },
                    6: {
                        text: 'Łowcy okazji',
                        type: 'promo',
                        gaLabel: 'badge_discount-hunters',
                        dataTrc: 'productThumb.discountHunters'
                    },
                    7: {
                        text: 'Top!',
                        type: 'promo-circle',
                        gaLabel: 'badge_top',
                        dataTrc: '8.12'
                    }
                };
            }
        },
        methods: {
            emitClick(name) {
                this.$emit('labelClicked', name);
            },
            couponClicked(e) {
                this.emitClick('badge_coupon');
                if (this.isLightboxEnabled) {
                    this.$emit('couponClicked', e);
                }
            },
            getType(label){
                if(label.badgeType === 7){
                    return this.labels[label.badgeType].type + ' ' + this.labelsGroups.topProductsBackgroundClass
                        + ' ' + this.labelsGroups.topProductsFontCssClass;
                }
                return this.labels[label.badgeType].type;
            }
        }
    };
</script>
